/* src/app/features/renuncia/consulta-protocolo/protocolo-renuncia-listagem.component.scss */
/*# sourceMappingURL=protocolo-renuncia-listagem.component.css.map */
